import type { ApiV1, ApiV2 } from '@teamworksdev/influencer/core';
import { isAuthenticated } from '@/stores/authStore';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

const LOG_PREFIX = '[CustomerIo]';

let cioAnalyticsInstance: AnalyticsBrowser | null = null;

const initCustomerIo = () => {
	if (!import.meta.env.MODE.startsWith('production')) return;

	if (cioAnalyticsInstance) return;

	const writeKey = import.meta.env.VITE_CUSTOMERIO_API_KEY;
	if (!writeKey) {
		console.warn(`${LOG_PREFIX} Write Key not configured`);
		return;
	}

	cioAnalyticsInstance = AnalyticsBrowser.load({ writeKey });
};

const identifyCustomerIo = (user: ApiV2.User, profile?: ApiV1.FullUserProfile) => {
	if (!import.meta.env.MODE.startsWith('production')) return;
	if (!isAuthenticated()) return;

	if (!cioAnalyticsInstance) {
		console.warn(`${LOG_PREFIX} Not initialized`);
		return;
	}

	const userId = profile?.axle_data?.user_id ?? null;

	if (!userId) {
		console.warn(`${LOG_PREFIX} User ID not available`);
		return;
	}

	cioAnalyticsInstance.identify(userId, {
		email: user.email,
		first_name: user.first_name,
		last_name: user.last_name,
	});
};

function pageCustomerIo(routeName: string, path: string) {
	if (!import.meta.env.MODE.startsWith('production')) {
		console.debug(`[Customer IO] Page updated: ${routeName} (${path})`);
	}

	if (!cioAnalyticsInstance) return;
	cioAnalyticsInstance.page(routeName, {
		path,
		// Deliberately collapses query strings to align with
		// GM implementation
		search: '',
	});
}

const resetCustomerIo = () => {
	if (!cioAnalyticsInstance) return;
	cioAnalyticsInstance.reset();
};

export {
	initCustomerIo,
	identifyCustomerIo,
	pageCustomerIo,
	resetCustomerIo,
};
